<ul nz-menu [nzMode]="nzMode" [class]="class">

    @if (showNavMenuOption('dashboards', '')) {
    <li nz-menu-item [routerLink]="['/dashboards']" [nzSelected]="currentRoute === '/dashboards'">Dashboards</li>
    }

    <li nz-submenu nzTitle="Órdenes">
        <ul>
            <li nz-menu-item [routerLink]="['/production-orders']" [nzSelected]="currentRoute === '/production-orders'">Órdenes</li>

            @if (showNavMenuOption('productionProcesses', '')) {
            <li nz-menu-item [routerLink]="['/production-processes']"
                [nzSelected]="currentRoute === '/production-processes'">Procesos de producción</li>
            }

            @if (showNavMenuOption('productionRoutes', '')) {
            <li nz-menu-item [routerLink]="['/production-routes']" [nzSelected]="currentRoute === '/production-routes'">
                Rutas de producción
            </li>
            }
        </ul>
    </li>

    @if (showNavMenuOption('validatePauses', '') || showNavMenuOption('pauseReasons', '')) {
    <li nz-submenu [nzTitle]="pauseTitle" (click)="navigateTo('/validate-pauses')">
        <ng-template #pauseTitle>
            <nz-badge [nzCount]="countPauses" [nzSize]="'small'" [nzOffset]="[8,0]">
                <a [class]=" nzMode === 'horizontal' ? 'text-white' : ''">Pausas</a>
            </nz-badge>
        </ng-template>
        @if (showNavMenuOption('pauseReasons', '')) {
        <ul>
            @if (showNavMenuOption('validatePauses', '')) {
            <li nz-menu-item [routerLink]="['/validate-pauses']" [nzSelected]="currentRoute === '/validate-pauses'">
                Validación de pausas</li>
            }

            <li nz-menu-item [routerLink]="['/pause-reasons']" [nzSelected]="currentRoute === '/pause-reasons'">
                Motivos de pausa</li>
        </ul>
        }
        @else {
        <ul hidden>
            <li nz-menu-item [nzSelected]="currentRoute === '/validate-pauses'"></li>
        </ul>
        }
    </li>
    }

    @if (showNavMenuOption('machinesDashboard', '') || showNavMenuOption('machines', '') ||
    showNavMenuOption('machineMeasurements', '')) {
    <li nz-submenu nzTitle="Máquinas">
        <ul>
            @if (showNavMenuOption('machines', '')) {
            <li nz-menu-item [routerLink]="['/machines']" [nzSelected]="currentRoute === '/machines'">
                Máquinas</li>
            }

            @if (showNavMenuOption('machineMeasurements', '')) {
            <li nz-menu-item [routerLink]="['/machine-measurements']"
                [nzSelected]="currentRoute === '/machine-measurements'">
                Valores de máquina</li>
            }
        </ul>
    </li>
    }

    @if (showNavMenuOption('maintenanceRequests', '') || showNavMenuOption('maintenances', '')
    || showNavMenuOption('maintenancesCalendar', '') ||
    showNavMenuOption('preventiveMaintenances','')) {
    <li nz-submenu nzTitle="Mantenimiento">
        <ul>
            @if (showNavMenuOption('maintenanceRequests', '')) {
            <li nz-menu-item [routerLink]="['/maintenance-requests']"
                [nzSelected]="currentRoute === '/maintenance-requests'">Solicitudes</li>
            }

            @if (showNavMenuOption('maintenances', '')) {
            <li nz-menu-item [routerLink]="['/maintenances']" [nzSelected]="currentRoute === '/maintenances'">
                Mantenimientos</li>
            }

            @if (showNavMenuOption('maintenancesCalendar', '')) {
            <li nz-menu-item [routerLink]="['/maintenances-calendar']"
                [nzSelected]="currentRoute === '/maintenances-calendar'">Calendario</li>
            }

            @if (showNavMenuOption('preventiveMaintenances', '')) {
            <li nz-menu-item [routerLink]="['/preventive-maintenances']"
                [nzSelected]="currentRoute === '/preventive-maintenances'">Mantenimientos preventivos
            </li>
            }
        </ul>
    </li>
    }

    <li nz-submenu nzTitle="Artículos">
        <ul>
            @if (showNavMenuOption('articles', '')) {
            <li nz-menu-item [routerLink]="['/articles']" [nzSelected]="currentRoute === '/articles'">
                Artículos</li>
            }

            @if (showNavMenuOption('articleTypes', '')) {
            <li nz-menu-item [routerLink]="['/article-types']" [nzSelected]="currentRoute === '/article-types'">
                Tipos de artículo</li>
            }

            @if (showNavMenuOption('articleFamilies', '')) {
            <li nz-menu-item [routerLink]="['/article-families']" [nzSelected]="currentRoute === '/article-families'">
                Familias de artículo</li>
            }

            @if (showNavMenuOption('articles', '')) {
            <li nz-menu-item [routerLink]="['/consumption-report']" [nzSelected]="currentRoute === '/consumption-report'">
                Consumos</li>
            }

            @if (showNavMenuOption('packagings', '') || showNavMenuOption('packagingsTypes', '')) {
            <li nz-submenu nzTitle="Formatos">
                <ul>
                    @if (showNavMenuOption('packagingsTypes', '')) {
                    <li nz-menu-item [routerLink]="['/packaging-types']" [nzSelected]="currentRoute === '/packaging-types'">
                        Tipos de formatos</li>
                    }

                    @if (showNavMenuOption('packagings', '')) {
                    <li nz-menu-item [routerLink]="['/packagings']" [nzSelected]="currentRoute === '/packagings'">Formatos
                    </li>
                    }
                </ul>
            </li>
            }
        </ul>
    </li>

    @if (showNavMenuOption('scrapCauses', '') || showNavMenuOption('scrapReasons', '')) {
    <li nz-submenu nzTitle="Taras y mermas">
        <ul>
            @if (showNavMenuOption('scrapCauses', '')) {
            <li nz-menu-item [routerLink]="['/scrap-causes']" [nzSelected]="currentRoute === '/scrap-causes'">Causas
                de tara</li>
            }

            @if (showNavMenuOption('scrapReasons', '')) {
            <li nz-menu-item [routerLink]="['/scrap-reasons']" [nzSelected]="currentRoute === '/scrap-reasons'">
                Razones de tara</li>
            }

            @if (showNavMenuOption('lossReasons', '')) {
            <li nz-menu-item [routerLink]="['/loss-reasons']" [nzSelected]="currentRoute === '/loss-reasons'">
                Razones de merma</li>
            }
        </ul>
    </li>
    }

    @if (showNavMenuOption('users', '') || showNavMenuOption('customers', '') ||
    showNavMenuOption('lossReasons', '') || showNavMenuOption('statuses', '')){
    <li nz-submenu nzTitle="Más">
        <ul>
            @if (showNavMenuOption('screens', '')) {
            <li nz-menu-item [routerLink]="['/screens']" [nzSelected]="currentRoute === '/screens'"> Pantallas</li>
            }

            @if (showNavMenuOption('users', '')) {
            <li nz-menu-item [routerLink]="['/users']" [nzSelected]="currentRoute === '/users'">Usuarios</li>
            }

            @if (showNavMenuOption('customers', '')) {
            <li nz-menu-item [routerLink]="['/customers']" [nzSelected]="currentRoute === '/customers'">
                Clientes</li>
            }

            @if (showNavMenuOption('statuses', '')) {
            <li nz-menu-item [routerLink]="['/statuses']" [nzSelected]="currentRoute === '/statuses'">
                Estados</li>
            }
        </ul>
    </li>
    }
</ul>
